var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BigNumber } from "ethers";
import { useContext } from "react";
import { VaultVersionList } from "../constants/constants";
import { isSolanaChain } from "../utils/chains";
import { SubgraphDataContext } from "./subgraphDataContext";
export var balancesGraphql = function (account, chain) { return "\n  balanceUpdates(\n    " + (isSolanaChain(chain)
    ? "where:{account:{_eq:\"" + account + "\"}}"
    : "where:{account:\"" + account + "\"}") + ",\n    " + (isSolanaChain(chain)
    ? "order_by: { timestamp: desc },"
    : "orderBy: timestamp,\n           orderDirection: desc,") + "\n    " + (isSolanaChain(chain) ? "limit: 1000" : "first: 1000") + "\n  ) {\n    vault {\n      symbol\n      name\n    }\n    timestamp\n    balance\n    yieldEarned\n    isWithdraw\n  }\n"; };
export var resolveBalancesSubgraphResponse = function (responses) {
    return VaultVersionList.flatMap(function (version) {
        return responses[version] && responses[version].balanceUpdates
            ? responses[version].balanceUpdates.reverse().map(function (item) { return (__assign(__assign({}, item), { balance: BigNumber.from(item.balance), yieldEarned: BigNumber.from(item.yieldEarned), vaultVersion: version })); })
            : [];
    }).sort(function (a, b) { return (a.timestamp > b.timestamp ? 1 : -1); });
};
var useBalances = function () {
    var contextData = useContext(SubgraphDataContext);
    var balances = contextData.vaultSubgraphData.balances;
    return {
        balances: balances,
        loading: contextData.vaultSubgraphData.loading,
    };
};
export default useBalances;
//# sourceMappingURL=useBalances.js.map